import { Action, Reducer } from 'redux';
import { assign, set } from 'lodash/fp';

import {
  REFERRAL_RESET,
  REFERRAL_SET_CODE,
  REFERRAL_SET_TARGET_SEGMENT,
  REFERRAL_SET_URL,
} from '../../actions/action-types';
import { TARGET_SEGMENT } from '../../cms/constants';

type SetCode = Action & {
  code: string | null;
};

type SetTargetSegment = Action & {
  targetSegment: string;
};

type SetUrl = Action & {
  url: string | null;
};

type ActionType = SetCode | SetTargetSegment | SetUrl;

type ReferralState = {
  code: string | null;
  targetSegment: string;
  url: string | null;
};

const getDefaultState = (): ReferralState => ({
  code: null,
  targetSegment: TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE,
  url: null,
});

const referralReducer: Reducer<ReferralState, ActionType> = (
  // eslint-disable-next-line default-param-last -- this is a conflict between eslint and redux
  state = getDefaultState(),
  action,
): ReferralState => {
  const reducers = {
    [REFERRAL_RESET]: () => assign(state, getDefaultState()),
    [REFERRAL_SET_CODE]: () => set('code', (action as SetCode).code, state),
    [REFERRAL_SET_TARGET_SEGMENT]: () => set('targetSegment', (action as SetTargetSegment).targetSegment, state),
    [REFERRAL_SET_URL]: () => set('url', (action as SetUrl).url, state),
  };

  const reducer = reducers?.[action.type as keyof typeof reducers];
  return reducer ? reducer() : state;
};

export default referralReducer;
